import React from 'react';
import {useStoreState} from 'easy-peasy';
import {useParams, useSearchParams} from 'react-router-dom';
import StoryboardViewContainer from '@/views/storyboard/StoryboardViewContainer';
import useData from '@/utils/useData';
import CellLoader from '@/components/loading/CellLoader';
import {Story} from '@/entities/story';

interface CustomerDetailDashboardViewProps {
  customerId?: string;
}

const CustomerDetailDashboardView: React.FC<CustomerDetailDashboardViewProps> = React.memo(({customerId}) => {
    const urlParams = useParams();
    const [searchParams] = useSearchParams();
    const customerIdToUse = customerId || urlParams.customerId;
    const activeStoryObject = useStoreState((state: any) => state.activeStoryObject.activeStoryObject) || customerIdToUse;
    
    const [personsStories, loadingPersonsStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'personsStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'personsStories'},
        },
    });

    if (loadingPersonsStories) {
        return <CellLoader fullHeight={true} />;
    }

    const story = personsStories.find((s: Story) => s.assignedUrl === 'customers');
    if (!story) {
        return <div>Dashboard not found for customers</div>;
    }

    const storyboardParam = searchParams.get('storyboard');
    const slugParam = searchParams.get('slug');
    const activeStoryboardHashid = storyboardParam || story.firstStoryboardHashid;
    const activeStoryboardUrl = slugParam || story.firstStoryboardSlug;

    return (
        <StoryboardViewContainer
            key={`${activeStoryboardHashid}-${activeStoryboardUrl}-${activeStoryObject}`}
            activeStoryboardHashid={activeStoryboardHashid}
            activeStoryUrl="customers"
            activeStoryboardUrl={activeStoryboardUrl}
            activeStoryObject={activeStoryObject}
            hideNavigation={false}
        />
    );
});

export default CustomerDetailDashboardView;
